/* eslint-disable react-hooks/rules-of-hooks */
import { REQUIRED_FIELD } from 'src/utils/Constants'
import z from 'zod'
const validaOperacional = () => {
  return z.object({
    despesaOperacional: z.number({ required_error: REQUIRED_FIELD }).positive(),
    custoFinanceiro: z
      .number({ required_error: REQUIRED_FIELD })
      .min(0)
      .nullable(),
    margemSeguranca: z
      .number({ required_error: REQUIRED_FIELD })
      .min(0)
      .nullable(),
    comissao: z.number({ required_error: REQUIRED_FIELD }).min(0).nullable(),
  })
}

export { validaOperacional }
